(() => {
  const ATTRIBUTE_NAME = 'Christmas Box';

  const updateCartAttribute = async (url, value) => {
    const response = await fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: JSON.stringify({ attributes: { [ATTRIBUTE_NAME]: value } }),
    });

    if (!response.ok) throw new Error(`Cart attribute update failed: ${response.status}`);
    return response.json();
  };

  class AmacaChristmasBox extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized === 'true') return;
      this.dataset.initialized = 'true';

      this.input = this.querySelector('[data-amaca-christmas-toggle]');
      this.status = this.querySelector('[data-amaca-christmas-status]');
      if (!this.input) return;

      this.confirmedState = this.input.checked;
      this.input.addEventListener('change', (event) => {
        event.stopPropagation();
        this.saveChoice();
      });
    }

    setCheckoutBusy(isBusy) {
      document.querySelectorAll('button[name="checkout"], input[name="checkout"]').forEach((control) => {
        if (isBusy) {
          control.dataset.amacaWasDisabled = control.disabled ? 'true' : 'false';
          control.disabled = true;
          control.setAttribute('aria-busy', 'true');
        } else {
          control.disabled = control.dataset.amacaWasDisabled === 'true';
          control.removeAttribute('aria-busy');
          delete control.dataset.amacaWasDisabled;
        }
      });
    }

    async saveChoice() {
      const requestedState = this.input.checked;
      const value = requestedState ? this.dataset.selectedValue : '';

      this.input.disabled = true;
      this.status.classList.remove('is-error');
      this.status.textContent = '';
      this.setCheckoutBusy(true);

      try {
        await updateCartAttribute(this.dataset.updateUrl, value);
        this.confirmedState = requestedState;
      } catch (error) {
        this.input.checked = this.confirmedState;
        this.status.classList.add('is-error');
        this.status.textContent = this.dataset.errorMessage;
        console.error(error);
      } finally {
        this.input.disabled = false;
        this.setCheckoutBusy(false);
      }
    }
  }

  class AmacaChristmasBoxReset extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized === 'true') return;
      this.dataset.initialized = 'true';
      this.clearStaleChoice();
    }

    async clearStaleChoice() {
      try {
        await updateCartAttribute(this.dataset.updateUrl, '');
      } catch (error) {
        window.setTimeout(() => updateCartAttribute(this.dataset.updateUrl, '').catch(console.error), 1200);
        console.error(error);
      }
    }
  }

  if (!customElements.get('amaca-christmas-box')) {
    customElements.define('amaca-christmas-box', AmacaChristmasBox);
  }

  if (!customElements.get('amaca-christmas-box-reset')) {
    customElements.define('amaca-christmas-box-reset', AmacaChristmasBoxReset);
  }
})();
